export enum ParametersEnum {
  ORDER_DETAIL_PRICE_CASH = 'ORDER_DETAIL_PRICE_CASH',
  ORDER_DETAIL_PRICE_CREDIT = 'ORDER_DETAIL_PRICE_CREDIT',
  DFLT_ORDER_SPACING = 'DFLT_ORDER_SPACING',
  PREASSIGN_LOADS = 'PRE-ASSIGN_LOADS',
  ARKIK_OT_JURISDICTION_PLANT = 'ARKIK_OT_JURISDICTION_PLANT',
  RMS_OT_OPEN_ORD = 'RMS_OT_OPEN_ORD',
  CONTACT_PHONE_DUMMY_VALUE = 'CONTACT_PHONE_DUMMY_VALUE',
  CONTACT_EMAIL_DUMMY_VALUE = 'CONTACT_EMAIL_DUMMY_VALUE',
  CONTACT_PH_CODE_DUMMY_VALUE = 'CONTACT_PH_CODE_DUMMY_VALUE',
  COPY_INTERNAL_INFORMATION = 'ARKIK_OT_COPY_INTERNAL',
}

export enum PaymentTermCode {
  CREDIT = 2,
}

export enum ParameterScopeTypeId {
  PLANT = 1,
  SUB_GROUP = 2,
  GROUP = 3,
  COUNTRY = 4,
  GENERIC = 5,
}

export enum ParameterGralValue {
  TRUE = '1',
  FALSE = '0',
}
